/* istanbul ignore file */
import { stringify } from 'query-string'

import { MpxSearchQueryModel } from '../models/MpxSearchQuery'
import { MpxQueryTrigger, MpxSearchQuery, MpxSearchResult } from '../types/MpxSearchTypes'

import { getMpAgent } from './utils'

const agent = getMpAgent()

const PATHS = {
  SEARCH: '/mpx/search/fullTextNonCompact',
  MORE_LIKE_THIS: '/mpx/search/moreLikeThis',
}

export class MpxSearch {
  static async query(query: MpxSearchQuery, trigger?: MpxQueryTrigger) {
    const queryModel = new MpxSearchQueryModel(query)
    const serverQuery = queryModel.toServerQuery()

    serverQuery.trigger = trigger
    serverQuery.showPoints = true

    return agent.get<MpxSearchResult>(`${PATHS.SEARCH}?${stringify(serverQuery)}`).then(r => r.data)
  }
}
